module.exports = __webpack_public_path__ + "static/media/luckia.ce1e92ed.png";